import { Form } from 'antd';
import { useEffect, useMemo } from 'react';

import { useGetClientFieldValuesQuery } from '@app/api/Client/api';
import { useUserPrint } from '@app/hooks';

interface UseClientImportantFieldsProps {
  clientId: number | null;
}

/**
 * Важные дополнительные поля клиента для окна записи. Значения живут в форме
 * записи под ключами ['ClientFieldValues', FieldId] и отправляются вместе с
 * сохранением записи (см. useRecordDetails). Пустые незаполненные поля тоже
 * показываем — в модалке их можно заполнить.
 */
export const useClientImportantFields = ({
  clientId,
}: UseClientImportantFieldsProps) => {
  const {
    params: { ActiveBranchId },
  } = useUserPrint();
  const recordForm = Form.useFormInstance();

  const { data: fieldValues } = useGetClientFieldValuesQuery(
    { ActiveBranchId, clientId: clientId ?? 0 },
    { skip: !clientId || !ActiveBranchId }
  );

  const importantFields = useMemo(
    () => (fieldValues ?? []).filter(({ IsImportant }) => IsImportant),
    [fieldValues]
  );

  // Засеять значения в форму записи; уже тронутые пользователем поля не
  // перезаписываем (иначе перерисовка затирала бы ввод).
  useEffect(() => {
    importantFields.forEach(({ FieldId, Value }) => {
      const fieldName = ['ClientFieldValues', String(FieldId)];
      if (!recordForm.isFieldTouched(fieldName)) {
        recordForm.setFieldValue(fieldName, Value ?? '');
      }
    });
  }, [importantFields, recordForm]);

  return { importantFields };
};
